var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_3243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5731 3.74333C23.4354 3.01981 23.1669 2.36019 22.7943 1.83017C22.4216 1.30015 21.9578 0.918215 21.4491 0.7224C19.5867 0 12.091 0 12.091 0C12.091 0 4.59492 0.0218666 2.73248 0.744267C2.22375 0.940093 1.75996 1.32205 1.3873 1.85209C1.01465 2.38214 0.746126 3.04178 0.60848 3.76533C0.0451362 8.47173 -0.173395 15.6432 0.623949 20.1613C0.761609 20.8849 1.03014 21.5445 1.40279 22.0745C1.77545 22.6045 2.23923 22.9865 2.74795 23.1823C4.61039 23.9047 12.1063 23.9047 12.1063 23.9047C12.1063 23.9047 19.602 23.9047 21.4644 23.1823C21.9731 22.9865 22.4369 22.6045 22.8096 22.0745C23.1823 21.5445 23.4508 20.8849 23.5885 20.1613C24.1827 15.4483 24.3658 8.2812 23.5731 3.74333Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70508 17.0746L15.9233 11.9522L9.70508 6.82983V17.0746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_3243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.103149)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.37e7ea7bdc72f0e24b2c048d346c1a17.svg";
export { ForwardRef as ReactComponent };